import { useIntl } from 'react-intl'
import styled from 'styled-components'

import MarkdownRender from 'LuxKit/MarkdownRender'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'

const StyledFacilities = styled(MarkdownRender)`
  > ul {
    columns: auto 2;
  }
`

const TwoColumns = styled.div`
  ${mediaQueryUp.tablet} {
    columns: 2;

    > * {
      break-inside: avoid;
    }
  }
`

const FacilitiesList = styled.ul`
  list-style-type: none;
  margin: 0;
`

type Props = {
  facilities: string
} | {
  amenities: Array<App.Property.AmenityGroup>
}

function PropertyFacilitiesModal(props: Props) {
  const intl = useIntl()

  const modalTitle = intl.formatMessage({
    id: 'l9zqg_3glZLL7DlJxQv-',
    defaultMessage: 'Facilities',
    description: 'Title for facilities modal on single property page',
  })

  return <Modal title={modalTitle} size="L">
    <BodyText variant="medium">
      {'facilities' in props && <StyledFacilities content={props.facilities} fontSize="medium" type="compact" />}
      {'amenities' in props && <TwoColumns>
        {props.amenities.map(amenityGroup => (
          <div key={amenityGroup.name}>
            <BodyText variant="medium" weight="bold">{amenityGroup.name}</BodyText>
            <FacilitiesList>
              {amenityGroup.items.map(item => (
                <li key={item.name}>{item.name}</li>
              ))}
            </FacilitiesList>
          </div>
        ))}
      </TwoColumns>}
    </BodyText>
  </Modal>
}

export default PropertyFacilitiesModal
